package com.milta.core.localization.translations.pl

import com.milta.core.localization.ErrorStrings

internal val Errors = ErrorStrings(
    generic = "Wystąpił błąd",
    error = "Błąd",
    fieldRequired = "To pole jest wymagane",
    invalidEmail = "Nieprawidłowy adres email",
    fileTooLarge = "Plik jest zbyt duży. Wybierz lżejszy plik.",
)
